<template>
  <div class="p-profile g-page">
    <v-loading-spinner :overlay="true" v-if="loading" />
    <v-grid>
      <div slot="gridItem" type="4">
        <h3>Partner Profile</h3>
        <v-form :onSubmit="validateForm" action="#" method="post" data-vv-scope="profile">
          <div slot="row">
            <b>Account Type</b>
            <p>Full Partner</p>
          </div>
          <div slot="row">
            <b>Partner Name</b>
            <v-input
              type="text"
              placeholder="Partner Name"
              v-model="profile.name"
              v-validate="'required'"
              data-vv-name="name"
              data-vv-as="name"
              data-vv-scope="profile"
              :class="{ 'a-input--error': errors.has('profile.name') }"
              data-test="profile-name" />
            <v-message type="error" subtype="basic" v-show="errors.has('profile.name')">
              <icon slot="icon" name="times"></icon>
              <span slot="text">{{ errors.first('profile.name') }}</span>
            </v-message>
          </div>
          <div slot="row">
            <b>Partner Email</b>
            <v-input
              type="text"
              placeholder="Partner Email"
              v-model="profile.email"
              v-validate="'required|email'"
              data-vv-name="email"
              data-vv-as="email"
              data-vv-scope="profile"
              :class="{ 'a-input--error': errors.has('profile.email') }"
              data-test="profile-email" />
            <v-message type="error" subtype="basic" v-show="errors.has('profile.email')">
              <icon slot="icon" name="times"></icon>
              <span slot="text">{{ errors.first('profile.email') }}</span>
            </v-message>
          </div>
          <div slot="formButtons">
            <v-button type="cta-1" subtype="submit" class="float-right" href="#">
              <icon name="check"></icon>
              <span>Save</span>
            </v-button>
          </div>
        </v-form>
      </div>
      <div slot="gridItem" type="8">
        <h3>Billing and Payment Methods</h3>
        <v-message type="info" fullwidth>
          <icon slot="icon" name="info-circle" />
          <span slot="text">{{ $t('functional.comingSoon') }}</span>
        </v-message>
      </div>
    </v-grid>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { VButton, VInput, VLoadingSpinner, VMessage } from '@signable/ui-kit/src/atoms';
import { VForm, VGrid } from '@signable/ui-kit/src/organisms';

export default {
  name: 'dashboard',
  inject: {
    $validator: '$validator',
  },
  components: {
    VButton,
    VInput,
    VLoadingSpinner,
    VMessage,
    VForm,
    VGrid,
  },
  data() {
    return {
      loading: true,
      profile: {},
      // isSearching: false,
    };
  },
  created() {
    this.$store.dispatch('user/GET').then(() => {
      this.profile = this.$store.getters['user/partner'];
      this.loading = false;
    });
  },
  methods: {
    validateForm(scope) {
      this.$validator.validateAll(scope).then((validated) => {
        if (validated) {
          this.loading = true;
          this.$store.dispatch('user/UPDATE', this.profile).then(() => { this.loading = false; });
        }
      });
    },
  },
};
</script>
